import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";

import UserDropdown from "./UserDropdown";

const iconSpeaker = new URL(
  "../assets/images/icon-speaker.svg",
  import.meta.url
);
const iconSpeakerMuted = new URL(
  "../assets/images/icon-speaker-muted.svg",
  import.meta.url
);
const iconTp = new URL("../assets/images/tp.svg", import.meta.url);
const logo = new URL("../assets/images/logo-group.svg", import.meta.url);
const iconUser = new URL("../assets/images/icon-user.svg", import.meta.url);

export default function Video({
  video,
  thumb,
  isHeroVideo,
  children,
  height,
  showBookingForm,
  loadedDelay = 300,
}) {
  const [tpHeight, setTpHeight] = useState(160);
  const [videoContainerHeight, setVideoContainerHeight] = useState("");
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [isMuted, setMuted] = useState(true);
  const [shouldRemoveImage, setShouldRemoveImage] = useState(false);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });
  const refVideo = useRef();
  const refUserIcon = useRef();

  useEffect(() => {
    if (height) {
      setInnerHeight(height);
    }
  }, []);

  useEffect(() => {
    if (isHeroVideo) {
      setVideoContainerHeight(`${window.innerHeight - tpHeight}px`);
    } else {
      setVideoContainerHeight("100%");
    }
  }, []);

  const onLoadedVideo = () => {
    setTimeout(() => {
      setIsVideoLoaded(true);
    }, loadedDelay);
    setTimeout(() => {
      setShouldRemoveImage(true);
    }, loadedDelay + 500);
  };

  return (
    <div
      className="relative overflow-hidden"
      ref={ref}
      style={{ height: innerHeight ?? window.innerHeight + "px" }}
    >
      {isHeroVideo && (
        <div className="absolute w-full z-40 top-16 flex justify-center items-center">
          <img
            ref={refUserIcon}
            src={iconUser}
            className="absolute left-5 cursor-pointer"
            onClick={() => setShowUserDropdown(!showUserDropdown)}
          />
          <img src={logo} width={230} className="ml-[30px]" />
          {showUserDropdown && (
            <UserDropdown
              top={refUserIcon.current.offsetTop + 70}
              onClose={() => setShowUserDropdown(!showUserDropdown)}
              showBookingForm={showBookingForm}
            />
          )}
        </div>
      )}

      <div
        className="flex flex-col"
        style={{ height: innerHeight ?? window.innerHeight + "px" }}
      >
        <div
          className="relative overflow-hidden"
          style={{ height: videoContainerHeight }}
        >
          {children}
          {isHeroVideo && isVideoLoaded && (
            <button
              className="absolute z-30 bottom-5 right-2 p-2"
              onClick={() => {
                setMuted(!isMuted);
                refVideo.current.muted = !refVideo.current.muted;
              }}
            >
              <img src={isMuted ? iconSpeakerMuted : iconSpeaker} />
            </button>
          )}
          {!shouldRemoveImage && (
            <div
              className="absolute z-10 w-full h-full transition-all duration-500"
              style={{
                opacity: inView && isVideoLoaded ? 0 : 1,
              }}
            >
              <img
                src={thumb}
                className="w-full h-full object-cover"
                alt="thumb"
              />
            </div>
          )}
          {((inView && video) || (isVideoLoaded && video)) && (
            <video
              ref={refVideo}
              autoPlay
              playsInline
              muted
              loop
              src={video}
              className="w-screen h-full object-cover"
              style={{ transform: "scale(1.01)" }}
              onLoadedData={onLoadedVideo}
              preload="none"
            />
          )}
        </div>
        {isHeroVideo && (
          <div
            className="bg-dark-blue text-white flex flex-col justify-center"
            style={{ height: `${tpHeight}px` }}
          >
            <div className="mx-10">
              <img src={iconTp} className="mb-3" />
              <div>
                Lyhörda och professionella. Hjälpte oss att ordna en fantastisk
                begravning som verkligen kändes som vår mamma.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
